import { isAfter, isBefore, isValid } from 'date-fns';

export function validate(
    value: Date,
    minDate: Date,
    maxDate: Date,
): { [key: string]: any } {
    if (value != null) {
        if (!isValid(value)) {
            /** TODO revise. possibly match {ngbDate: {invalid: value}}; */
            return { dateInvalid: value };
        }

        if (minDate && isBefore(value, minDate)) {
            /** TODO revise. possibly match {ngbDate: {minDate: {minDate: this.minDate, actual: value}}}; */
            return { dateMin: { minDate, actual: value } };
        }

        if (maxDate && isAfter(value, maxDate)) {
            /** TODO revise. possibly match {ngbDate: {maxDate: {maxDate: this.maxDate, actual: value}}}; */
            return { dateMax: { maxDate, actual: value } };
        }
    }

    return null;
}
